import React from "react";

export const LightboxNavigationButton = ({
	onClick,
	direction,
	title = undefined,
}) => {
	return (
		<button
			className={`product-lightbox__navigation-arrow arrow-${direction}`}
			onClick={onClick}
			title={title}
		>
			<span className="arrow" />
		</button>
	);
};
